module.exports = __webpack_public_path__ + "static/media/donor.bef5a1a6.png";